
































































import { CommitteeViewModelInterface } from "@share/committees/committee/types/CommitteeViewModel";
import { Vue, Component, Prop } from "vue-property-decorator";

import Speaker from '@share/session/components/Speaker.vue';
import ItemsList from "@share/common/ItemsList.vue";

@Component({ components: { ItemsList, Speaker } })

export default class S1Information extends Vue {

    @Prop() committee: CommitteeViewModelInterface;

    isCopied = false;
    copyTimeout: NodeJS.Timeout | null = null;

    fallback(text: string) {
        const isIos = navigator.userAgent.match(/ipad|iphone/i);
        const textarea = document.createElement('textarea');

        // create textarea
        textarea.value = text;

        // ios will zoom in on the input if the font-size is < 16px
        textarea.style.fontSize = '20px';
        document.body.appendChild(textarea);

        // select text
        if (isIos) {
            const range = document.createRange();
            range.selectNodeContents(textarea);

            const selection = window.getSelection();
            selection?.removeAllRanges();
            selection?.addRange(range);
            textarea.setSelectionRange(0, 999999);
        } else {
            textarea.select();
        }

        // copy selection
        document.execCommand('copy');

        // cleanup
        document.body.removeChild(textarea);
    }

    copy() {

        if(!this.committee.link) {
            return
        }

        if(!navigator.clipboard) {
            this.fallback(this.committee.link);
        }
        else {
            navigator.clipboard.writeText(this.committee.link);
        }

        this.isCopied = true;

        if(this.copyTimeout) {
            clearTimeout(this.copyTimeout)
        }

        this.copyTimeout = setTimeout(() => {
            this.isCopied = false;
        }, 5000);
    }
}

